module.exports = __webpack_public_path__ + "static/boardsOfKaneda-7758ac0ea65f435e729b53c53c7b35bd.jpg";